import { saveKey } from './api.js';
import { $ } from './dom.js';
import { G } from './screens/nav.js';

// ── INITIALIZATION ──────────────────────────────────────────────
// Keyboard shortcuts and modal handlers.
// During Vue migration, move to component onMounted() hooks.

// Platform-aware keyboard shortcut labels
const IsMac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

document.querySelectorAll('.kbd-hint').forEach(el => {
  el.textContent = IsMac ? '⌘' : 'Ctrl+';
});

// API key modal enter handler
$('api-inp')?.addEventListener('keydown', e => {
  if (e.key === 'Enter') {
    saveKey();
  }
});

// Publish modal handlers
$('cf-token-inp')?.addEventListener('keydown', e => {
  if (e.key === 'Enter') {
    $('cf-project-inp')?.focus();
  }
});
$('cf-project-inp')?.addEventListener('keydown', e => {
  if (e.key === 'Enter') {
    G.doPublish();
  }
});
$('cf-project-inp')?.addEventListener('input', e => {
  const clean = e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '');
  const preview = $('cf-url-preview');
  if (preview) {
    preview.textContent = clean || 'your-project';
  }
});
